import { api } from "./axios";

interface GetAllTransactionsParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

interface GetUserInvoicesParams {
  page?: number;
  limit?: number;
}

interface Invoice {
  id: number;
  invoiceNumber: string;
  amount: number;
  currency: string;
  creditsPurchased: number;
  packageName: string;
  invoiceDate: string;
  status: string;
}

export const transactionApi = {
  getAllUserTransactions: ({
    page = 1,
    limit = 10,
    search = "",
    status = "",
  }: GetAllTransactionsParams = {}) => {
    const params = new URLSearchParams();

    params.append("page", page.toString());
    params.append("limit", limit.toString());

    if (search) params.append("search", search);
    if (status) params.append("status", status);

    return api.get(`/transaction/user-transactions?${params}`);
  },

  getAllTransactionHistories: ({
    page = 1,
    limit = 10,
    search = "",
    status = "",
  }: GetAllTransactionsParams = {}) => {
    const params = new URLSearchParams();

    params.append("page", page.toString());
    params.append("limit", limit.toString());

    if (search) params.append("search", search);
    if (status) params.append("status", status);

    return api.get(`/transaction/histories?${params}`);
  },

  getAllStripeProducts: () => {
    return api.get("/stripe/products");
  },

  getUserInvoices: ({ page = 1, limit = 10 }: GetUserInvoicesParams = {}) => {
    const params = new URLSearchParams();

    params.append("page", page.toString());
    params.append("limit", limit.toString());

    return api.get(`/transaction/invoices?${params}`);
  },
};
